<template>
  <div class="product-grid">
    <div class="d-flex justify-center mb-10" id="products">
      <!-- style="color: white;" -->
      <h2 >{{ $t('Products') }}</h2>
    </div>
     <v-row class="px-5">
        <v-col md="3" cols="6" v-for="product in products" :key="`product-${product.id}`">
          <product-card :product="product" />
        </v-col>
        <v-col md="3" cols="6" v-for="n in 4" :key="'skeleton-' + n" v-if="loading">
          <div class="skeleton-card"></div>
        </v-col>
      </v-row>
      <div v-if="products.length === 0" class="empty-state">
        <p>No products match your criteria. Try clearing filters.</p>
        <button @click="$router.push({ query: {} })" class="clear-filters-btn">
          Clear All Filters
        </button>
      </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, } from 'vuex';
import ProductCard from './ProductCard.vue';
export default {
  name: 'ProductGrid',
  components: { ProductCard },
  computed: {
    ...mapGetters({
      products: 'products/getProducts',
      loading: 'products/getLoadingStatus',
      hasMore: 'products/getHasMore',
    })
  },
  data: () => ({
    filters: {},
  }),
  watch: {
    '$route.query': {
      handler() {
        this.resetAndFetch()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    resetAndFetch() {
      this.$store.commit('products/setPage', 1);
      this.$store.commit('products/setHasMore', true);
      this.filters = {
        brand_id: this.$route.query.brand_id,
        category_id: this.$route.query.category_id,
      }; 
      const filterTemp = {};
      Object.keys(this.filters).forEach((key) => {
        if (this.filters[key]) filterTemp[key] = this.filters[key];
      });
      this.fetchB2cProducts(filterTemp)
    },
    ...mapActions({
      fetchB2cProducts: 'products/fetchB2cProducts'
    }),
    handleScroll() {
      const bottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;
      if (bottom && !this.loading && this.hasMore) {
        const filterTemp = {};
        Object.keys(this.filters).forEach((key) => {
          if (this.filters[key]) filterTemp[key] = this.filters[key];
        });
        this.fetchB2cProducts(filterTemp);
      }
    }
  },
  created() {
    this.fetchB2cProducts(); 
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>



<style scoped>
.skeleton-card {
  height: 320px;
  background: #eee;
  border-radius: 12px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}

.product-grid {
  padding: 20px 0;
  /* background: linear-gradient(135deg, #5a6a8a, #364359); */
}

.grid-header {
  margin-bottom: 30px;
}

.grid-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 10px 0;
}

.no-products {
  color: #666;
  font-size: 16px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin: 20px;
}

.empty-state {
  text-align: center;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-top: 40px;
}

.empty-state p {
  color: #666;
  font-size: 18px;
  margin-bottom: 20px;
}

.clear-filters-btn {
  padding: 12px 24px;
  background: #2ed573;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clear-filters-btn:hover {
  background: #26c463;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }

  .grid-header h2 {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>